import {
  EBloodGroup,
  EDayOfWeek,
  EGender,
  EGoodType,
  EMaritalStatus,
  EMedicamentType,
  EPackType,
  EPrescriptionsType,
  ERouteUseMedicine,
  EStatus,
  ETemplateExamDisplayType,
  EUnitType,
  EUnitType2
} from 'enums'
import { ENote } from 'enums/ENoteOption'
import { IOptionItem } from 'interfaces'
import { EObstetricsAndGynecology } from 'pages/accountSystemSetting/enums/EObstetricsAndGynecology'
import { ESubclinicalType } from 'pages/exam/enums'
import { EShiftSession } from 'pages/menuWorkingSchedule/enums'
import { EBookingStatus } from 'pages/patientBooking/enums'
import { EExamStatus } from 'pages/patientBooking/enums/EExamStatus'
import { EPaymentMethod, EPaymentStatus } from 'pages/patientPayment/enums'

export const COUNTRY_OPTIONS = [
  {
    label: 'country-vn',
    value: 'vn'
  }
]

export const GENDER_OPTIONS = [
  {
    label: 'male',
    value: EGender.Male
  },
  {
    label: 'female',
    value: EGender.Female
  }
]

export const MARITAL_STATUS_OPTIONS = [
  {
    label: 'married',
    value: EMaritalStatus.Married
  },
  {
    label: 'single',
    value: EMaritalStatus.Single
  }
]
export const JOB_OPTIONS = [
  { value: 'Sản xuất và chế biến', label: 'Sản xuất và chế biến' },
  { value: 'Kiến trúc và xây dựng', label: 'Kiến trúc và xây dựng' },
  { value: 'Kinh doanh', label: 'Kinh doanh' },
  { value: 'Công nghệ - thông tin', label: 'Công nghệ - thông tin' },
  { value: 'Luật - nhân văn', label: 'Luật - nhân văn' },
  {
    value: 'Nghệ thuật - thẩm mỹ - đồ hoạ',
    label: 'Nghệ thuật - thẩm mỹ - đồ hoạ'
  },
  {
    value: 'Báo chí - khoa học và xã hội',
    label: 'Báo chí - khoa học và xã hội'
  },
  { value: 'Khoa học cơ bản', label: 'Khoa học cơ bản' },
  { value: 'Sư phạm', label: 'Sư phạm' },
  { value: 'Nông - lâm - ngư nghiệp', label: 'Nông - lâm - ngư nghiệp' }
]
export const ACADEMIC_OPTIONS = [
  {
    label: 'dr',
    value: 'BS'
  },
  {
    label: 'masters-dr',
    value: 'Ths BS'
  },
  {
    label: 'degree-doctor',
    value: 'TS BS'
  },
  {
    label: 'dr-1',
    value: 'BS CKI'
  },
  {
    label: 'dr-2',
    value: 'BS CKII'
  },
  {
    label: 'assoc-prof-dr-bs',
    value: 'PGS TS BS'
  },
  {
    label: 'prof-dr-bs',
    value: 'GS TS BS'
  },
  {
    label: 'pharmacist',
    value: 'Dược Sĩ'
  },
  {
    label: 'nursing',
    value: 'Điều dưỡng'
  },
  {
    label: 'other',
    value: 'Khác'
  }
]

export const STATUS_OPTIONS = [
  {
    label: 'status-active',
    value: EStatus.Active
  },
  {
    label: 'status-de-active',
    value: EStatus.Inactive
  }
]

export const DAY_OPTIONS: Array<IOptionItem> = [
  { label: 'mon', value: EDayOfWeek.MON },
  { label: 'tue', value: EDayOfWeek.TUE },
  { label: 'wed', value: EDayOfWeek.WED },
  { label: 'thu', value: EDayOfWeek.THU },
  { label: 'fri', value: EDayOfWeek.FRI },
  { label: 'sat', value: EDayOfWeek.SAT },
  { label: 'sun', value: EDayOfWeek.SUN }
]

export const ALL_WEEK = [
  EDayOfWeek.MON,
  EDayOfWeek.TUE,
  EDayOfWeek.WED,
  EDayOfWeek.THU,
  EDayOfWeek.FRI,
  EDayOfWeek.SAT,
  EDayOfWeek.SUN
]

export const SECTION_DAY_OPTIONS = [
  { label: 'morning-shift', value: EShiftSession.MorningShift },
  {
    label: 'afternoon-shift',
    value: EShiftSession.AfternoonShift
  },
  { label: 'all-day', value: EShiftSession.AllDay },
  { label: 'day-off', value: EShiftSession.DayOff }
]

export const EXAMINATION_TYPE_OPTIONS = [
  { label: 'new-examination', value: 0 },
  { label: 're-examination', value: 1 }
]

export const PRIORITIZED_OPTIONS = [
  { label: 'priority-0', value: 0 },
  { label: 'priority-1', value: 1 }
]

export const EXAM_OPTIONS = [
  { label: 'exam-confirmed', value: EExamStatus.Confirmed },
  { label: 'waiting-examination', value: EExamStatus.Waiting },
  { label: 'being-examined', value: EExamStatus.InProgress },
  { label: 'data-collection', value: EExamStatus.DataCollection },
  { label: 'examed', value: EExamStatus.Finished },
  { label: 'doctor-reject', value: EExamStatus.Canceled }
]

export const BOOKING_STATUS_OPTIONS = [
  { label: 'booking-status-invalid', value: EBookingStatus.Invalid },
  { label: 'create-new', value: EBookingStatus.Created },
  { label: 'confirmed', value: EBookingStatus.Confirmed },
  { label: 'reject', value: EBookingStatus.Canceled },
  { label: 'in-progressing', value: EBookingStatus.InProgress },
  { label: 'complete', value: EBookingStatus.Finished }
]

export const PAYMENT_METHOD_STATUS_OPTIONS = [
  { label: `label-${EPaymentStatus.Paid}`, value: EPaymentStatus.Paid },
  { label: `label-${EPaymentStatus.UnPaid}`, value: EPaymentStatus.UnPaid },
  {
    label: `label-${EPaymentStatus.Deposited}`,
    value: EPaymentMethod.Advance
  },
  {
    label: `partial-paid`,
    value: EPaymentStatus.PartialPaid
  }
]

export const PAYMENT_METHOD_TYPE_OPTIONS = [
  { label: 'advance', value: EPaymentMethod.Advance },
  { label: 'payment-method-full-payment', value: EPaymentMethod.FullPayment },
  {
    label: 'payment-method-direct-payment',
    value: EPaymentMethod.DirectPayment
  }
]

export const SUBCLINICAL_TYPE_OPTIONS = [
  {
    label: `image-analysis`,
    value: ESubclinicalType.ImageAnalysis
  },
  {
    label: `medical-test`,
    value: ESubclinicalType.MedicalTest
  }
]

export const BLOOD_GROUP_OPTIONS = [
  {
    label: `label-${EBloodGroup.A}`,
    value: EBloodGroup.A
  },
  // {
  //   label: `label-${EBloodGroup.APlus}`,
  //   value: EBloodGroup.APlus
  // },
  {
    label: `label-${EBloodGroup.B}`,
    value: EBloodGroup.B
  },
  // {
  //   label: `label-${EBloodGroup.BPlus}`,
  //   value: EBloodGroup.BPlus
  // },
  {
    label: `label-${EBloodGroup.AB}`,
    value: EBloodGroup.AB
  },
  // {
  //   label: `label-${EBloodGroup.ABPlus}`,
  //   value: EBloodGroup.ABPlus
  // },
  {
    label: `label-${EBloodGroup.O}`,
    value: EBloodGroup.O
  }
  // {
  //   label: `label-${EBloodGroup.OPlus}`,
  //   value: EBloodGroup.OPlus
  // }
]

export const RH_BLOOD_TYPE_OPTIONS = [
  { label: 'Rh(D)+', value: 'Rh(D)+' },
  { label: 'Rh(D)-', value: 'Rh(D)-' }
]

export const GOOD_TYPE_OPTIONS = [
  {
    label: `label-medicine`,
    value: EGoodType.Medicament
  },
  {
    label: `label-medical-supplies`,
    value: EGoodType.MedicalSupplies
  },
  {
    label: `other`,
    value: EGoodType.Other
  }
]

export const MEDICAMENT_TYPE_OPTIONS = [
  {
    label: `Musculoskeletal`,
    value: EMedicamentType.Musculoskeletal
  },
  {
    label: `Allergy`,
    value: EMedicamentType.Allergy
  },
  {
    label: `ReduceFeverAndPain`,
    value: EMedicamentType.ReduceFeverAndPain
  },
  {
    label: `Respiratory`,
    value: EMedicamentType.Respiratory
  },
  {
    label: `Antibiotic`,
    value: EMedicamentType.Antibiotic
  },
  {
    label: `AntiInflammatory`,
    value: EMedicamentType.AntiInflammatory
  },
  {
    label: `Endocrine`,
    value: EMedicamentType.Endocrine
  },
  {
    label: `Psychoactive`,
    value: EMedicamentType.Psychoactive
  },
  {
    label: `Urinary`,
    value: EMedicamentType.Urinary
  },
  {
    label: `HepatobiliaryDigestive`,
    value: EMedicamentType.HepatobiliaryDigestive
  },
  {
    label: `Cardiovascular`,
    value: EMedicamentType.Cardiovascular
  },
  {
    label: `EyeDrops`,
    value: EMedicamentType.EyeDrops
  },
  {
    label: `FunctionalFoodVitamin`,
    value: EMedicamentType.FunctionalFoodVitamin
  }
]

export const PACK_TYPE_OPTIONS = [
  {
    label: `label-box`,
    value: EPackType.Box
  }
]

export const UNIT_TYPE_OPTIONS = [
  {
    label: EUnitType.Vien,
    value: EUnitType.Vien
  },
  {
    label: EUnitType.Hop,
    value: EUnitType.Hop
  },
  {
    label: EUnitType.Cai,
    value: EUnitType.Cai
  },
  {
    label: EUnitType.Chai,
    value: EUnitType.Chai
  },
  {
    label: EUnitType.Goi,
    value: EUnitType.Goi
  },
  {
    label: EUnitType.Hu,
    value: EUnitType.Hu
  },
  {
    label: EUnitType.Lieu,
    value: EUnitType.Lieu
  },
  {
    label: EUnitType.Loc,
    value: EUnitType.Loc
  },
  {
    label: EUnitType.Ong,
    value: EUnitType.Ong
  },
  {
    label: EUnitType.Tuyp,
    value: EUnitType.Tuyp
  },
  {
    label: EUnitType.Tui,
    value: EUnitType.Tui
  },
  {
    label: EUnitType.Kit,
    value: EUnitType.Kit
  },
  {
    label: EUnitType.Binh,
    value: EUnitType.Binh
  },
  {
    label: EUnitType.Bo,
    value: EUnitType.Bo
  },
  {
    label: EUnitType.Nang,
    value: EUnitType.Nang
  },
  {
    label: EUnitType.QueCay,
    value: EUnitType.QueCay
  },
  {
    label: EUnitType.ThanhCay,
    value: EUnitType.ThanhCay
  },
  {
    label: EUnitType.Thung,
    value: EUnitType.Thung
  },
  {
    label: EUnitType.Vi,
    value: EUnitType.Vi
  },
  {
    label: EUnitType.Lo,
    value: EUnitType.Lo
  },
  {
    label: EUnitType.Mieng,
    value: EUnitType.Mieng
  },
  {
    label: EUnitType.Cuon,
    value: EUnitType.Cuon
  }
]

export const UNIT_USAGE_OPTIONS = [
  {
    label: EUnitType2.Vien,
    value: EUnitType2.Vien
  },
  {
    label: EUnitType2.Goi,
    value: EUnitType2.Goi
  },
  {
    label: EUnitType2.Muong,
    value: EUnitType2.Muong
  },
  {
    label: EUnitType2.Giot,
    value: EUnitType2.Giot
  },
  {
    label: EUnitType2.Mieng,
    value: EUnitType2.Mieng
  },
  {
    label: EUnitType2.Cuon,
    value: EUnitType2.Cuon
  },
  {
    label: EUnitType2.Lan,
    value: EUnitType2.Lan
  },
  {
    label: EUnitType2.LanXit,
    value: EUnitType2.LanXit
  },
  {
    label: EUnitType2.Cai,
    value: EUnitType2.Cai
  },
  {
    label: EUnitType2.Ong,
    value: EUnitType2.Ong
  },
  {
    label: EUnitType2.Tuyp,
    value: EUnitType2.Tuyp
  },
  {
    label: EUnitType2.Lo,
    value: EUnitType2.Lo
  },
  {
    label: EUnitType2.Tui,
    value: EUnitType2.Tui
  },
  {
    label: EUnitType2.Kit,
    value: EUnitType2.Kit
  },
  {
    label: EUnitType2.Nang,
    value: EUnitType2.Nang
  },
  {
    label: EUnitType2.QueCay,
    value: EUnitType2.QueCay
  },
  {
    label: EUnitType2.ThanhCay,
    value: EUnitType2.ThanhCay
  },
  {
    label: EUnitType2.Ml,
    value: EUnitType2.Ml
  },
  {
    label: EUnitType2.Mg,
    value: EUnitType2.Mg
  },
  {
    label: EUnitType2.IU,
    value: EUnitType2.IU
  }
]
export const ROUTE_USE_MEDICINE_TYPE_OPTIONS = [
  {
    label: `label-drink`,
    value: ERouteUseMedicine.Drink
  },
  {
    label: 'label-dissolve-in-mouth',
    value: ERouteUseMedicine.DissolveInMouth
  },
  {
    label: 'label-chew',
    value: ERouteUseMedicine.Chew
  },
  {
    label: 'label-place-under-tongue',
    value: ERouteUseMedicine.PlaceUnderTongue
  },
  {
    label: 'label-oral-swabbing',
    value: ERouteUseMedicine.OralSwabbing
  },
  {
    label: 'label-hold-under-tongue',
    value: ERouteUseMedicine.HoldUnderTongue
  },
  {
    label: 'label-intramuscular-injection',
    value: ERouteUseMedicine.IntramuscularInjection
  },
  {
    label: 'label-subcutaneous-injection',
    value: ERouteUseMedicine.SubcutaneousInjection
  },
  {
    label: 'label-intradermal-injection',
    value: ERouteUseMedicine.IntradermalInjection
  },
  {
    label: 'label-intravenous-injection',
    value: ERouteUseMedicine.IntravenousInjection
  },
  {
    label: 'label-intravenous-infusion',
    value: ERouteUseMedicine.IntravenousInfusion
  },
  {
    label: 'label-joint-cavity-injection',
    value: ERouteUseMedicine.JointCavityInjection
  },
  {
    label: 'label-intravitreal-injection',
    value: ERouteUseMedicine.IntravitrealInjection
  },
  {
    label: 'label-vitreous-injection',
    value: ERouteUseMedicine.VitreousInjection
  },
  {
    label: 'label-body-cavity-injection',
    value: ERouteUseMedicine.BodyCavityInjection
  },
  {
    label: 'label-injection',
    value: ERouteUseMedicine.Injection
  },
  {
    label: 'label-tumor-arterial-injection',
    value: ERouteUseMedicine.TumorArterialInjection
  },
  {
    label: 'label-natural-cavity-injection',
    value: ERouteUseMedicine.NaturalCavityInjection
  },
  {
    label: 'label-tumor-injection',
    value: ERouteUseMedicine.TumorInjection
  },
  {
    label: 'label-infusion-therapy',
    value: ERouteUseMedicine.InfusionTherapy
  },
  {
    label: 'label-general-infusion',
    value: ERouteUseMedicine.GeneralInfusion
  },
  {
    label: 'label-apply',
    value: ERouteUseMedicine.Apply
  },
  {
    label: 'label-rub-externally',
    value: ERouteUseMedicine.RubExternally
  },
  {
    label: 'label-skin-patch',
    value: ERouteUseMedicine.SkinPatch
  },
  {
    label: 'label-skin-spray',
    value: ERouteUseMedicine.SkinSpray
  },
  {
    label: 'label-external-use',
    value: ERouteUseMedicine.ExternalUse
  },
  {
    label: 'label-vaginal-placement',
    value: ERouteUseMedicine.VaginalPlacement
  },
  {
    label: 'label-rectal-placement',
    value: ERouteUseMedicine.RectalPlacement
  },
  {
    label: 'label-rectal-and-anal-enema',
    value: ERouteUseMedicine.RectalAndAnalEnema
  },
  {
    label: 'label-placement',
    value: ERouteUseMedicine.Placement
  },
  {
    label: 'label-uterine-placement',
    value: ERouteUseMedicine.UterinePlacement
  },
  {
    label: 'label-enema',
    value: ERouteUseMedicine.Enema
  },
  {
    label: 'label-mist-spray',
    value: ERouteUseMedicine.MistSpray
  },
  {
    label: 'label-inhalation',
    value: ERouteUseMedicine.Inhalation
  },
  {
    label: 'label-inhalation-powder',
    value: ERouteUseMedicine.InhalationPowder
  },
  {
    label: 'label-general-spray',
    value: ERouteUseMedicine.GeneralSpray
  },
  {
    label: 'label-nebulization',
    value: ERouteUseMedicine.Nebulization
  },
  {
    label: 'label-nasal-throat-inhalation',
    value: ERouteUseMedicine.NasalAndThroatInhalation
  },
  {
    label: 'label-respiratory-route',
    value: ERouteUseMedicine.RespiratoryRoute
  },
  {
    label: 'label-nasal-spray',
    value: ERouteUseMedicine.NasalSpray
  },
  {
    label: 'label-throat-spray',
    value: ERouteUseMedicine.ThroatSpray
  },
  {
    label: 'label-nasal-medicine',
    value: ERouteUseMedicine.NasalMedicine
  },
  {
    label: 'label-nasal-drops',
    value: ERouteUseMedicine.NasalDrops
  },
  {
    label: 'label-eye-drops',
    value: ERouteUseMedicine.EyeDrops
  },
  {
    label: 'label-eye-ointment',
    value: ERouteUseMedicine.EyeOintment
  },
  {
    label: 'label-ophthalmic-medicine',
    value: ERouteUseMedicine.OphthalmicMedicine
  },
  {
    label: 'label-ear-drops',
    value: ERouteUseMedicine.EarDrops
  },
  {
    label: 'label-skin-application',
    value: ERouteUseMedicine.SkinApplication
  },
  {
    label: 'label-close-to-tumor',
    value: ERouteUseMedicine.CloseToTumor
  },
  {
    label: 'label-gas-bottle',
    value: ERouteUseMedicine.GasBottle
  },
  {
    label: 'label-compressed-gas-bottle',
    value: ERouteUseMedicine.CompressedGasBottle
  },
  {
    label: 'label-rectal-application',
    value: ERouteUseMedicine.RectalApplication
  },
  {
    label: 'label-clean-tongue-coating',
    value: ERouteUseMedicine.CleanTongueCoating
  },
  {
    label: 'label-tumor-implantation',
    value: ERouteUseMedicine.TumorImplantation
  },
  {
    label: 'label-external-radiation',
    value: ERouteUseMedicine.ExternalRadiation
  },
  {
    label: 'label-solution',
    value: ERouteUseMedicine.Solution
  },
  {
    label: 'label-washing-solution',
    value: ERouteUseMedicine.WashingSolution
  },
  {
    label: 'label-dialysis-solution',
    value: ERouteUseMedicine.DialysisSolution
  },
  {
    label: 'label-spray',
    value: ERouteUseMedicine.Spray
  },
  {
    label: 'label-bag',
    value: ERouteUseMedicine.Bag
  },
  {
    label: 'label-suspension',
    value: ERouteUseMedicine.Suspension
  },
  {
    label: 'label-lyophilized-powder',
    value: ERouteUseMedicine.LyophilizedPowder
  }
]

export const INDICATIONS_MEDICATION_OPTIONS = [
  {
    label: `label-drink`,
    value: ERouteUseMedicine.Drink
  }
]

export const STATUS_ACTIVE_OPTIONS = [
  {
    label: 'active',
    value: 2
  },
  {
    label: 'de-active',
    value: 1
  }
]

export const TEMPLATE_EXAMINATION_DISPLAY_TYPE = [
  { label: 'select-option', value: ETemplateExamDisplayType.Option },
  { label: 'self-enter-information', value: ETemplateExamDisplayType.Input }
]

export const PRESCRIPTIONS_TYPE_OPTIONS = [
  { label: 'buy-medicine-internal', value: EPrescriptionsType.BuyInternal },
  { label: 'buy-medicine-outside', value: EPrescriptionsType.BuyOutside }
]

export const OBSTETRICS_GYNECOLOGY_OPTIONS = [
  {
    label: EObstetricsAndGynecology.Obstetrics,
    value: EObstetricsAndGynecology.Obstetrics
  },
  {
    label: EObstetricsAndGynecology.Gynecology,
    value: EObstetricsAndGynecology.Gynecology
  }
]
export const NOTE_OPTIONS = [
  {
    label: ENote.AfterMeal,
    value: ENote.AfterMeal
  },
  {
    label: ENote.BeforeMeal,
    value: ENote.BeforeMeal
  },
  {
    label: ENote.DuringMeal,
    value: ENote.DuringMeal
  },
  {
    label: ENote.WhenSick,
    value: ENote.WhenSick
  },
  {
    label: ENote.BeforeSleep,
    value: ENote.BeforeSleep
  }
]
